import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

export default function GenericDialog({
  isOpen,
  setIsOpen,
  header,
  headerIcon,
  onUpperRightClick,
  upperRightIcon,
  children,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  header: string;
  headerIcon: React.ReactNode;
  onUpperRightClick?: () => void;
  upperRightIcon?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setIsOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 lg:left-56 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-xl transform rounded-lg bg-white py-4 lg:py-6 px-4 lg:px-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex justify-between items-center">
                    <div className="text-xl font-semibold leading-6 text-slate-700 flex items-center">
                      {headerIcon}
                      <span className="ml-2">{header}</span>
                    </div>
                    {upperRightIcon && (
                      <button onClick={onUpperRightClick}>
                        {upperRightIcon}
                      </button>
                    )}
                  </div>
                  <div className="mt-5 space-y-6">{children}</div>
                  <div className="mt-4 flex justify-end">
                    <button
                      className="bg-red-600 text-white rounded px-4 p-2 hover:bg-red-800 font-semibold"
                      onClick={() => setIsOpen(false)}
                    >
                      Done
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
